import { defineComponent as l, computed as u, openBlock as t, createElementBlock as i, renderSlot as c, createBlock as d, createCommentVNode as s, toDisplayString as o } from "vue";
import v from "./novoui-vuejs12.js";
const f = {
  key: 0,
  class: "input-assistive"
}, m = { key: 1 }, g = { key: 2 }, h = /* @__PURE__ */ l({
  __name: "NAssistiveText",
  props: {
    /**
     * The assistive text to be displayed below the input field
     */
    assistiveText: {
      type: String,
      default: ""
    },
    /**
     * The error message to be displayed below the input field
     */
    errorMessage: {
      type: String,
      default: ""
    },
    /**
     * Whether the input field is invalid
     */
    invalid: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const r = e, a = u(() => r.invalid && r.errorMessage);
    return (n, p) => e.assistiveText || a.value || n.$slots.default ? (t(), i("div", f, [
      c(n.$slots, "default", {}, () => [
        e.invalid ? (t(), d(v, {
          key: 0,
          icon: "warning",
          size: 12
        })) : s("", !0),
        a.value ? (t(), i("span", m, o(e.errorMessage), 1)) : s("", !0),
        e.assistiveText && !a.value ? (t(), i("span", g, o(e.assistiveText), 1)) : s("", !0)
      ])
    ])) : s("", !0);
  }
});
export {
  h as default
};
